/** Keep native Blob reads below browser allocation/transfer limits. */
export const BLOB_CHUNK_BYTES = 4 * 1024 * 1024;

export async function readBlobText(blob: Blob): Promise<string> {
  if (blob.size <= BLOB_CHUNK_BYTES) return blob.text();
  const decoder = new TextDecoder();
  const parts: string[] = [];
  for (let start = 0; start < blob.size; start += BLOB_CHUNK_BYTES) {
    const bytes = await blob.slice(start, start + BLOB_CHUNK_BYTES).arrayBuffer();
    // A UTF-8 character can straddle the binary chunk boundary.
    parts.push(decoder.decode(bytes, { stream: true }));
  }
  parts.push(decoder.decode());
  return parts.join('');
}
